import React from "react";

import { FixedNameCell } from ".";

export const VehicleNameCell = ({ vehicle, history, match }) => {
    const openVehicleDetails = () => {
        const { path } = match;
        const { id, V_ID: sourceVehicleId } = vehicle;
        history.push(`${path}/vehicle/${sourceVehicleId}/Overview/${id}`);
    };

    return (
        <FixedNameCell vehicle={vehicle}>
            <div className="vehicle-name" onClick={openVehicleDetails}>
                {vehicle.displayName}
            </div>
        </FixedNameCell>
    )
};
